<footer class="bg-dark position-relative" style="height: 50px;padding: 0;width: 100%;">
    <div class="container-lg text-center text-light" style="padding: 0;">
        <div class="row align-items-center" style="margin: 0;height: 50px;">
            <div class="col-4 col-md-3 col-lg-3 offset-md-1 offset-lg-2 text-md-start">
                <a class="btn px-0 py-0 text-light" data-bs-toggle="modal" data-bs-target="#modalContactsId">
                    <span class="fs-7">contatti</span>
                </a>
            </div>
            <div class="col-4 col-md-4 col-lg-2">
                <!--
                @if(permissionService()?.isUserAuthenticated()) {
                    <a class="btn px-0 py-0 text-light" routerLink="/privacyPolicy">
                        <span class="fs-7">privacy policy</span>
                    </a>
                }
                @else {
                    <a class="btn px-0 py-0 text-light" data-bs-toggle="modal" data-bs-target="#modalPrivacyPolicyId">
                        <span class="fs-7">privacy policy</span>
                    </a>
                }
                -->
                <a class="btn px-0 py-0 text-light" routerLink="/privacyPolicy">
                    <span class="fs-7">privacy policy</span>
                </a>
            </div>
            <div class="col-4 col-md-3 col-lg-3 text-md-end">
                <a class="btn px-0 py-0 text-light" routerLink="/serviceConditions">
                    <span class="fs-7">condizioni di servizio</span>
                </a>
            </div>
        </div>
    </div>
    <span class="fs-9 text-info position-absolute" style="bottom:2px;left:2px;">© 2025 Tutti i diritti riservati.</span>
</footer>

<div class="modal modal-md fade" id="modalContactsId">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable px-2 my-0 mt-5">
        <div class="modal-content text-bg-primary">
            
            <!-- Modal body -->
            <div class="modal-body">
                <div class="row mx-2 mt-2">
                    <div class="col p-0 z-1">
                        <h4 class="text-center">Contatti</h4>
                    </div>
                </div>
                <div class="row mx-2 mt-2">
                    <div class="col text-center">
                        <span class="fs-5">Supporto e assistenza</span><br>
                        <a href="mailto:{{emailSupport}}"><span class="text-warning text-info fs-4">{{emailSupport}}</span></a>
                        &nbsp;&nbsp;
                        <a class="btn px-0 py-0" title="copia email" (click)="copyEmailSupportToClipboard()">
                            <span class="bi bi-copy text-info fs-6"></span>
                        </a>
                    </div>
                </div>
                <div class="row mx-2 mt-4">
                    <div class="col col-1 col-md-1">
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <span class="text-light">Geom. Luca Caroleo</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-1">
                                <span class="bi bi-telephone text-success fs-6"></span>
                            </div>
                            <div class="col">
                                <span class="fs-7">(+39) 340.5197080</span>
                            </div>
                        </div>
                        <div class="row opacity-50">
                            <div class="col col-1">
                                <span class="bi bi-telephone fs-6 text-success"></span>
                            </div>
                            <div class="col">
                                <span class="fs-7">(+39) 351.3180622</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-1">
                                <span class="bi bi-envelope text-success fs-6"></span>
                            </div>
                            <div class="col">
                                <span class="fs-7">studio@geometracaroleo.it</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-1">
                                <span class="bi bi-envelope-check-fill text-success fs-6"></span>
                            </div>
                            <div class="col">
                                <span class="fs-7">luca.caroleo@geopec.it</span>
                            </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col col-1">
                                <span class="bi bi-house text-success fs-6"></span>
                            </div>
                            <div class="col">
                                <span class="fs-7">P.zza Camillo Cavour n. 6<br>13100 Vercelli (VC)</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mx-2 mt-4 mb-4">
                    <div class="col text-end text-info">
                        <span class=" fs-7 text-nowrap">credits: Giorgio Restano - IT manager</span><br>  
                        <!-- <span class=" fs-7">Giorgio Restano</span><br> -->
                        <span class="fs-7">giorgio.restano@tanocom.it</span>
                    </div>
                </div>
                <div class="row mx-2 mt-3">
                    <div class="col text-center">
                        <button type="button" data-bs-target="#modalContactsId" data-bs-dismiss="modal" class="btn btn-primary link-light text-bg-success position-relative">chiudi</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--
<div class="modal modal-lg fade" id="modalPrivacyPolicyId">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable px-2 my-0 mt-5">
        <div class="modal-content text-bg-primary">
            <!-- Modal body 
            <div class="modal-body">
                <div class="row mx-2 mt-2">
                    <div class="col p-0 z-1">
                        <h4 class="text-center">Informativa privacy</h4>
                    </div>
                </div>
                <div class="row mx-2 mt-2">
                    <div class="col">
                        <span class="fs-5">Coming soon</span>
                    </div>
                </div>
                <div class="row mx-2 mt-3">
                    <div class="col text-center">
                        <button type="button" data-bs-target="#modalPrivacyPolicyId" data-bs-dismiss="modal" class="btn btn-primary link-light text-bg-success position-relative">chiudi</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal modal-lg fade" id="modalServiceConditionsId">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable px-2 my-0 mt-5">
        <div class="modal-content text-bg-primary">
            <!-- Modal body 
            <div class="modal-body">
                <div class="row mx-2 mt-2">
                    <div class="col p-0 z-1">
                        <h4 class="text-center">Condizioni di servizio</h4>
                    </div>
                </div>
                <div class="row mx-2 mt-2">
                    <div class="col">
                        <span class="fs-5">Coming soon</span>
                    </div>
                </div>
                <div class="row mx-2 mt-3">
                    <div class="col text-center">
                        <button type="button" data-bs-target="#modalServiceConditionsId" data-bs-dismiss="modal" class="btn btn-primary link-light text-bg-success position-relative">chiudi</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
-->